export default __webpack_public_path__ + "static/media/reports.3e071151.yaml";